import React from 'react';
import { reduxForm, FieldArray } from 'redux-form';

import { PreviewQuestion } from '../previewQuestion/previewQuestion';

import { ColorPickerFieldComponent } from 'components/form/color-picker/color-picker-field.component';
import { AppTextField } from 'components/form/appTextField';
import { AppFileField } from 'components/form/appFileField';
import { FieldArrayRenderer } from 'components/form/fieldArrayRenderer/fieldArrayRenderer';

export const PreviewTemplate = reduxForm<any, any>({})(() => (
  <>
    <div>Styling</div>
    <ColorPickerFieldComponent name="style.color" label="Color" disabled placeholder="-" />
    <AppFileField name="style.logo" label="Logo" disabled placeholder="-" />
    <div>Survey</div>
    <AppTextField name="survey.details" label="Details" disabled placeholder="-" />
    <FieldArray name="survey.questions" component={FieldArrayRenderer} fieldComponent={PreviewQuestion} />
  </>
));
